import { HandleSubAccount } from "../components/signup/HandleSubAccount";

export function HandleSubAccountPage() {
  return <HandleSubAccount />;
}
